import { DocumentType, PackageTypeId } from '@models/document';
import { Button, IButtonProps } from '../Button';
import { useDownloadQuoteDocument } from './useDownloadQuoteDocument';

export type DownloadApplicationButtonProps = {
  quoteId: string;
  quoteUpdatedDate: Date;
  /** Optional label, @default 'Download Application' */
  label?: string;
  buttonProps?: IButtonProps;
};

export const DownloadApplicationButton = ({
  quoteId,
  quoteUpdatedDate,
  label = 'Download Application',
  buttonProps,
}: DownloadApplicationButtonProps) => {
  const { isLoading, isDisabled, handleDownloadQuoteDocument } = useDownloadQuoteDocument({
    quoteId,
    createdOnOrAfterDate: quoteUpdatedDate,
    documentTypeId: DocumentType.Application.id,
    packageTypeId: PackageTypeId.Application,
    downloadType: 'auto',
  });

  const handleDownloadApplicationClick = () => {
    handleDownloadQuoteDocument();
  };

  return (
    <Button
      data-testid='Download-Application'
      target='_blank'
      isLoading={isLoading}
      onClick={() => handleDownloadApplicationClick()}
      variant={buttonProps?.variant ?? 'outlined'}
      disabled={isDisabled}
      {...buttonProps}
    >
      {label}
    </Button>
  );
};
